module.exports = __webpack_public_path__ + "ed21ec8205bca298c4d4ec908c88f7f7.png";